import { CalendarOrder } from '../entities/CalendarOrder';

/**
 * カレンダー向けの発注情報を生成するファクトリ
 */
export class CalendarOrderFactory {
  /**
   * 発注情報を生成する
   * @param data - 発注情報
   */
  public static create = (data: Partial<CalendarOrder>): CalendarOrder => {
    return {
      parentBusinessId: data.parentBusinessId || '',
      unit: data.unit || undefined,
      businessName: data.businessName || undefined,
      arrivalId: data.arrivalId || '',
      amount: data.amount || 0,
      leadTime: data.leadTime || 0,
      isFixOrdered: data.isFixOrdered || undefined,
      fixOrderDate: data.fixOrderDate || undefined,
      crossDate: data.crossDate || undefined,
      status: data.status || undefined,
      year: data.year || 0,
      month: data.month || 0,
      day: data.day || 0,
      warehouse: data.warehouse || '',
      supplierName: data.supplierName || '',
      package: data.package || '',
      businessNumber: data.businessNumber || '',
      outputDate: data.outputDate || undefined,
      isOutOfStockExpected: data.isOutOfStockExpected || false,
      memoText: data.memoText || '',
      number: data.number,
      updateAt: data.updateAt || 0,
      orderGroupId: data.orderGroupId || undefined,
      partialDeliveries: undefined, // 分納の情報はカレンダーでは不要
    };
  };
}
